/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import Filters from "../../components/Filters";
import { ControlTable } from "../../components/Table";
import { chain, findIndex, get, isEmpty } from "lodash";
import { getProductsList } from "../../apis/companies/products";
import { getParams } from "../../utils/params";
import { ITEM_SEARCH_OPTIONS } from "../../constants/ITEM";
import Modal, { ModalHeader } from "../Modal";
import Button from "../Button";
import useForm from "../../hooks/useForm";
import { transformComma } from "../../utils/validator/comma";
import Guide from "../Guide";

const defulatForm = {
  searchType: "name",
  searchText: "",
  order: [
    {
      idx: "desc",
    },
  ],
  page: 0,
  limit: 10,
};

// 품목 추가 mode : slow, quick
const SelectItemList = ({ open, setOpen, form, setForm, itemIdx, isSales=true }) => {
  const [fields, setFields] = useState([]);
  const filters = [
    {
      title: "품목분류 선택",
      type: "select",
      key: "searchType",
      options: {
        list: ITEM_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ];
  const [mode, setMode] = useState('slow')
  const [itemList, setItemList] = useState([])

  useEffect(() => {
    setFields([
      {
        isHide: mode === 'slow',
        title: '수량', key: 'count', type: 'comma'
      },
      { title: "품목분류", key: "category" },
      { title: "품목명", key: "name" },
      { title: "품목코드", key: "code" },
      { title: "규격", key: "size" },
      { title: "구분", key: "division" },
      { title: "단위", key: "unit" },
      { title: "재고", key: "qty", type: 'comma' },
      { title: "매입단가", key: "buyPrice", type: "comma" },
      { title: "판매단가", key: "sellPrice", type: "comma" },
      { title: "메모", key: "memo" },
    ])
    if (mode === 'quick')
    {
      setItemList(form.filter(item => !!item.idx).map(item => ({ ...item, count: Number(item.qty) })))
    }
  }, [mode])

  const {
    values,
    setValues,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    selectedData,
    setSelectedData,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
  } = useForm(defulatForm);

  useEffect(() => {
    if (open)
    {
      submit(values);
      setSubmit(submit);
    }
  }, [open]);

  const submit = useCallback((params) => {
    setIsLoading(true);
    getProductsList({
      ...getParams(params),
    })
      .then((res) => {
        setTotal(res.data.count);

        res.data.products = res.data.products.map((product, idx) => ({
          ...product,
          buyPrice: String(product.buyPrice),
          sellPrice: String(product.sellPrice),
          count: Number(get(form.find(item => item.idx === product.idx), 'qty', 0))
        })
        );
        setList(get(res, "data.products"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [form]);

  const cancel = () => {
    setSelectedData({});
    setValues(defulatForm);
    setOpen(false);
  };

  const handleOnSupply = () => {
    if (mode === 'quick') return cancel();

    let newArray = [...form];
    newArray[itemIdx] = {
      ...newArray[itemIdx],
      prodIdx: selectedData.idx,
      prodName: selectedData.name,
      unit: selectedData.unit,
      unitCost: transformComma( isSales ? selectedData.sellPrice : selectedData.buyPrice),
    };

    setForm(newArray);

    cancel();
  };

  const handleRowClick = (data, e) => {
    if (mode !== 'quick') return;
    let count = data.count
    count++
    const index = findIndex(list, data)
    let newArray = [...list]
    newArray[index] = {
      ...data,
      count
    }
    setList(newArray)

    const supplyCost = count * (isSales ? newArray[index].sellPrice : newArray[index].buyPrice)
    const taxAmt = Math.ceil(supplyCost * 0.1)

    setItemList(oldVal => [...oldVal, {
      idx: newArray[index].idx,
      trMonth: new Date().getMonth() + 1,
      trDate: String(new Date().getDate()),
      prodName: newArray[index].name,
      unit: newArray[index].unit,
      qty: Number(count),
      unitCost: transformComma( isSales ? newArray[index].sellPrice : newArray[index].buyPrice),
      supplyCost: transformComma(supplyCost),
      taxAmt: transformComma(taxAmt),
      remark: "",
    }])
  }

  useEffect(() => {
    if (!isEmpty(itemList))
    {
      const quickItems = chain(itemList).orderBy(['idx', 'qty'], ['desc', 'desc']).uniqBy('idx').value()
      setForm(quickItems.map(i => ({ ...i, qty: String(i.qty) })))
    }
  }, [itemList])

  const getTableTitle = () => {
    if (mode !== "quick") return;
    return (
      <Guide className="w-full">
        품목 클릭 시 목록에 추가 됩니다. 다중 클릭 시 수량이 증가합니다.
      </Guide>
    )
  }

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="select-item-modal">
        <ModalHeader>품목 불러오기</ModalHeader>
        <Button
          className="mode-button"
          color="line"
          label={mode === 'slow' ? "퀵 모드 전환" : "일반 모드 전환"}
          action={() => setMode(mode === 'slow' ? 'quick' : 'slow')}
        />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={values}
          onChange={handleOnChange}
        />
        <ControlTable
          title={getTableTitle()}
          isSelect={mode === 'slow'}
          isLoading={isLoading}
          setSelectedData={setSelectedData}
          fields={fields}
          list={list}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
          onSelect={handleRowClick}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="적용하기"
            action={handleOnSupply}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SelectItemList;
